import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';

export default class GallerySelect extends React.PureComponent {
    static propTypes = {
        photo: PropTypes.object.isRequired,
        promotable: PropTypes.bool,
        isSelected: PropTypes.bool.isRequired,
        onSelect: PropTypes.func.isRequired
    };
    static defaultProps = {
        promotable: false
    };

    render() {
        const { photo, isSelected, promotable } = this.props;

        return (
            <div className={`component-gallery-select ${isSelected ? 'selected' : ''}`}>
                {promotable ?
                    <div className="promotable">
                        {
                            photo.controls.promote && photo.controls.promote.visible ?
                                <div className="promotable-button promote-button" onClick={() => photo.controls.promote.trigger(photo)}>
                                    <i className="fa fa-arrow-circle-o-up"></i>
                                </div>
                                : null
                        }
                        {
                            photo.controls.demote && photo.controls.demote.visible ?
                                <div className="promotable-button demote-button" onClick={() => photo.controls.demote.trigger(photo)}>
                                    <i className="fa fa-arrow-circle-o-down"></i>
                                </div>
                                : null
                        }
                    </div>
                    : null}
                <div className="select-checkbox" onClick={() => this.props.onSelect(photo)}>
                    <i className="fa fa-check"></i>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/layout/GallerySelect/index.js